import React from 'react';
import { Button, Table, Header, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

export default class Faculties extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],

        };
        this.getFaculties = this.getFaculties.bind(this);
        this.archive = this.archive.bind(this);
    }

    componentDidMount() {
        this.getFaculties();
    }

    getFaculties() {
        axios.get(`course/organizational-units/${this.props.location.state.id}`)
            .then(res => {
                const dataa = res.data;
                this.setState({ data: dataa });
            })
            .catch(err => {
                console.log('Failed to fetch courses');
            });
    }

    archive(id, optlock, courseBasicId, organizationalUnitId, mainFaculty) {
        let archiveCourse = {
            id, optlock, courseBasicId, organizationalUnitId, mainFaculty
        };

        axios.put('/course/basic/archive', { ...archiveCourse })
            .then(res => {
                toast('Predmet je uspješno arhiviran!');
            })
            .catch(err => {
                toast('Došlo je do greške! Predmet nije arhiviran.');
            });
        window.history.go(-1);
    }


    render() {
        return (
            <div>
                <Header as="h1">Detalji / arhiviranje</Header>
                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            {this.props.location.state.name}
                        </Header>
                    </Segment>
                    <Segment clearing>
                        <Table celled selectable compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>
                                        Fakulteti
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {this.state.data.map((el, index) =>
                                (<Table.Row key={index}>
                                    <Table.Cell verticalAlign="middle">
                                        {el.organizationalUnit.name}
                                    </Table.Cell>
                                    <Table.Cell textAlign="center">
                                        <Button
                                            color="red"
                                            basic="true"
                                            onClick={
                                                () => {
                                                    this.archive(
                                                        el.id,
                                                        el.optLock,
                                                        el.courseBasic.id,
                                                        el.organizationalUnit.id,
                                                        el.mainFaculty
                                                    );
                                                }
                                            }
                                        >
                                            Arhiviraj predmet
                                        </Button>
                                    </Table.Cell>


                                </Table.Row>))}
                            </Table.Body>
                        </Table>

                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateCourse/Faculties.js